import { v4 } from "uuid";
import { useDownloadStore } from "../utils/useDownloadStore";
import toast from "react-hot-toast";
import {getEndpoints} from "../utils/server-endpoints";

export function downloadAttachmentUsingWorker({ attachmentName, box, uid, isEncrypted, token, onComplete}) {
    const store = useDownloadStore.getState();
    const id = v4();
    const worker = new Worker("/download.worker.js");
    const channel = new MessageChannel();
    const body = { attachmentName, box, uid, isEncrypted }
    worker.postMessage(
        {
            id,
            name: attachmentName,
            postRequest: {
                url: getEndpoints().fetchAttachmentData.url,
                body,
                token,
            },
        },
        [channel.port2]
    );

    store.addDownload({
        id,
        name: attachmentName,
        progress: 0,
        done: false,
        workerRef: worker,
    });

    channel.port1.onmessage = (e) => {
        const { id: msgId, progress, done, json } = e.data;

        if (progress !== undefined) store.updateProgress(msgId, progress);
        if (done) {
            worker.terminate();
            if (onComplete && json) onComplete(body, json, id);
        }
    };
}

export function cancelDownload(id) {
    const store = useDownloadStore.getState();
    const target = store.activeDownloads.find((f) => f.id === id);
    if (target?.workerRef) {
        target.workerRef.terminate(); // kill the XHR
    }
    store.removeDownload(id);
    toast(`${target?.name || "File"} download canceled`);
}

